import { Content } from '@backstage/core-components';
import { PageShareTitle } from '../../lib/shareTitle';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { getStoredFunMode, translate } from '../i18n';

/**
 * Environment config editor tab on component entities that carry the
 * argocd/app-selector annotation. Renders EnvironmentConfigTab inside the
 * standard Content wrapper. Wiring is kept in sync by
 * packages/app/src/modules/configuration/environmentEntityContent.test.ts.
 */
export const environmentEntityContent = EntityContentBlueprint.make({
  name: 'environment',
  params: {
    path: '/environment',
    // Non-component config (evaluated once at extension registration), so
    // this reads the fun-mode flag directly instead of the useT() hook — see
    // the i18n module's non-component-code note.
    title: translate(
      'configuration.environmentEntityContent.title',
      getStoredFunMode(),
    ),
    group: 'configuration',
    filter: (entity: {
      kind: string;
      metadata: { annotations?: Record<string, string> };
    }) =>
      entity.kind === 'Component' &&
      Boolean(entity.metadata.annotations?.['argocd/app-selector']),
    loader: () =>
      import('./EnvironmentConfigTab').then(m => (
        <PageShareTitle title="Environment configuration">
          <Content>
            <m.EnvironmentConfigTab />
          </Content>
        </PageShareTitle>
      )),
  },
});
